import {
  Component,
  Input
} from '@angular/core';

@Component({
  selector: 'app-svg-sprite',
  template: `<svg [attr.height]='height' [attr.width]='width'>
                <g class="ball">
                  <use [attr.xlink:href]='hash' [attr.width]='width' [attr.height]='height' x='0' y='0'><title>{{title}}</title></use>
                </g>
            </svg>`
})
export class SVGSpriteComponent {
  //componentName: 'SVGSpriteComponent';
  private _name = '';
  @Input() hash: string;
  @Input() title: string;
  @Input() width: number;
  @Input() height: number;

  constructor() {
      this.hash = "_port100_ifa";
      this.width = 36;
      this.height = 36;
      this.title = "IFA Index Portfolio 100"
  }
}
